// AUTO-GENERATED from IamErrorCode.java — do not edit manually
// Run: ./scripts/generate-error-codes.sh

/* eslint-disable i18next/no-literal-string, no-restricted-syntax */
export const IamErrorCode = {
    GN0001_VERSION_CONFLICT: 'GN0001',
    GN0002_NOT_FOUND: 'GN0002',
    GN0003_ACCESS_DENIED: 'GN0003',
    GN0004_INTERNAL_ERROR: 'GN0004',
    GN0005_ALREADY_EXISTS: 'GN0005',
    GN0006_CONFLICT: 'GN0006',
    GN0007_PERMISSION_DENIED: 'GN0007',
    GN0008_ALREADY_IMPERSONATING: 'GN0008',
    GN0009_CANNOT_IMPERSONATE_SELF: 'GN0009',
    GN0010_IMPERSONATION_TARGET_NOT_FOUND: 'GN0010',
    GN0011_NOT_IMPERSONATING: 'GN0011',
    GN0012_CONFIG_ALREADY_EXISTS: 'GN0012',
    GN0013_OAUTH_NOT_CONFIGURED: 'GN0013',
    GN0014_TYPE_VALUE_IN_USE: 'GN0014',
    GN0015_DEMO_FAILURE: 'GN0015',
    GN0016_UNSUPPORTED_VALUE_TYPE: 'GN0016',
    GN0017_ATTRIBUTE_DEFINITION_USED_IN_TEMPLATE: 'GN0017',
    GN0018_UNKNOWN_RESPONSIBILITY: 'GN0018',
    GN0022_OWNER_PARTY_INACTIVE: 'GN0022',
    GN0023_OWNER_VALIDITY_RANGE_INVALID: 'GN0023',
    GN0019_DUPLICATE_FIELD_VALUE: 'GN0019',
    GN0020_DUPLICATE_RECORD: 'GN0020',
    GN0021_NOTIFICATION_TEMPLATE_INVALID: 'GN0021',
    GN0024_DUPLICATE_ENTITY_SINGLE: 'GN0024',
    GN0025_DUPLICATE_ENTITY_COMPOUND: 'GN0025',
    PT0001_NO_DISPLAY_NAME_TEMPLATE: 'PT0001',
    PT0002_DISPLAY_NAME_DERIVATION_BLANK: 'PT0002',
    TM0001_LEAD_MUST_BE_PERSON: 'TM0001',
    TM0002_CANNOT_BE_OWN_MEMBER: 'TM0002',
    TM0003_ALREADY_MEMBER: 'TM0003',
    TM0004_NOT_A_TEAM: 'TM0004',
    TM0005_CANNOT_DELETE_HAS_RESPONSIBILITIES: 'TM0005',
    TM0006_MEMBERSHIP_NOT_FOUND: 'TM0006',
    ID0001_ALREADY_SUSPENDED: 'ID0001',
    ID0002_TERMINATED_CANNOT_SUSPEND: 'ID0002',
    ID0003_ALREADY_ACTIVE: 'ID0003',
    ID0004_TERMINATED_CANNOT_ACTIVATE: 'ID0004',
    ID0005_ALREADY_TERMINATED: 'ID0005',
    ID0007_ENTRY_DATE_MUST_BE_FUTURE: 'ID0007',
    ID0008_ENTRY_DATE_ONLY_AWAITING_ENTRY: 'ID0008',
    ID0009_EXIT_DATE_TERMINATED: 'ID0009',
    ID0010_EXIT_DATE_BEFORE_ENTRY: 'ID0010',
    ID0011_IDENTIFIER_DUPLICATE: 'ID0011',
    ID0012_IDENTIFIER_INVALID_EMAIL: 'ID0012',
    ID0013_IDENTIFIER_INVALID_VALUE: 'ID0013',
    ID0014_RELATIONSHIP_ALREADY_ENDED: 'ID0014',
    ID0015_REACTIVATION_DATE_MUST_BE_FUTURE: 'ID0015',
    ID0016_REACTIVATION_DATE_ONLY_SUSPENDED: 'ID0016',
    ID0017_REHIRE_REQUIRES_TERMINATED: 'ID0017',
    ID0018_REHIRE_DATE_INVALID: 'ID0018',
    ID0019_REHIRE_REASON_REQUIRED: 'ID0019',
    ID0020_REHIRE_CANDIDATE_NOT_PENDING: 'ID0020',
    ID0021_REHIRE_DECISION_INVALID: 'ID0021',
    ID0022_ILLEGAL_LIFECYCLE_TRANSITION: 'ID0022',
    ID0023_LIFECYCLE_REASON_TOO_LONG: 'ID0023',
    SY0001_SELF_PARENT: 'SY0001',
    SY0002_DIFFERENT_SYSTEM: 'SY0002',
    SY0003_CYCLE_DETECTED: 'SY0003',
    SY0004_MAX_DEPTH_EXCEEDED: 'SY0004',
    SY0005_INVALID_TYPE_CODE: 'SY0005',
    SY0006_TYPE_VALUE_EXISTS: 'SY0006',
    SY0007_SCRIPT_NOT_TEMPLATE: 'SY0007',
    SY0008_CANNOT_EDIT_TEMPLATE: 'SY0008',
    SY0009_VERSION_ALREADY_PUBLISHED: 'SY0009',
    SY0010_VERSION_NOT_PUBLISHED: 'SY0010',
    SY0011_CANNOT_DELETE_PUBLISHED_SCRIPT: 'SY0011',
    SY0015_VERSION_MISMATCH: 'SY0015',
    SY0016_ALREADY_TEMPLATE: 'SY0016',
    SY0017_TEMPLATE_NO_VERSIONS: 'SY0017',
    SY0012_INVALID_TIMEOUT_FORMAT: 'SY0012',
    SY0013_STATEMENT_TIMEOUT_EXCEEDED: 'SY0013',
    SY0014_CONNECTOR_ALREADY_EXISTS: 'SY0014',
    SY0018_NOT_AN_ENTITY_TYPE_TABLE: 'SY0018',
    SY0019_INVALID_ICON: 'SY0019',
    SY0020_INVALID_COLOR: 'SY0020',
    SY0021_TEMPLATE_NOT_ALLOWED_FOR_TABLE: 'SY0021',
    SY0022_TEMPLATE_TOO_LONG: 'SY0022',
    SY0023_MENU_NOT_OBJECT: 'SY0023',
    SY0024_MENU_LABEL_REQUIRED: 'SY0024',
    SY0025_INVALID_MENU_FIELD: 'SY0025',
    AR0001_BENEFICIARY_NOT_ACTIVE: 'AR0001',
    AR0002_DUPLICATE_PROFILE: 'AR0002',
    AR0003_FUTURE_EXPIRY: 'AR0003',
    AR0004_EXPIRY_REQUIRED: 'AR0004',
    AR0005_MAX_DURATION_EXCEEDED: 'AR0005',
    AR0006_PENDING_EXISTS: 'AR0006',
    AR0007_ALREADY_ASSIGNED: 'AR0007',
    AR0008_NOT_PENDING: 'AR0008',
    AR0009_NO_ACTIVE_STEP: 'AR0009',
    AR0010_NOT_ASSIGNED_APPROVER: 'AR0010',
    AR0011_CANNOT_APPROVE_OWN: 'AR0011',
    AR0012_CANNOT_APPROVE_SELF: 'AR0012',
    AR0013_REJECTION_COMMENT_REQUIRED: 'AR0013',
    AR0014_DEFAULT_POLICY_NOT_MODIFIABLE: 'AR0014',
    AR0015_DEFAULT_POLICY_NOT_DELETABLE: 'AR0015',
    AR0016_STEP_ORDERS_NOT_UNIQUE: 'AR0016',
    AR0017_NO_APPROVERS_CONFIGURED: 'AR0017',
    AR0018_ALL_APPROVERS_EXCLUDED: 'AR0018',
    AR0019_BULK_VALIDATION_FAILED: 'AR0019',
    AU0001_ROLE_ALREADY_EXISTS: 'AU0001',
    AU0002_SYSTEM_ROLE_NOT_MODIFIABLE: 'AU0002',
    AU0003_SYSTEM_ROLE_NOT_DELETABLE: 'AU0003',
    AU0004_ROLE_ALREADY_ASSIGNED: 'AU0004',
    AU0005_ROLE_NOT_ASSIGNED: 'AU0005',
    AU0006_DUPLICATE_TASK_NAME: 'AU0006',
    AU0007_DYNAMIC_JOB_REQUIRED: 'AU0007',
    AU0008_CANNOT_DELETE_JOB_WITH_HISTORY: 'AU0008',
    AU0009_TASK_TEMPLATE_REQUIRED: 'AU0009',
    AU0010_TEMPLATE_DISABLED: 'AU0010',
    AU0011_JOB_ALREADY_EXISTS: 'AU0011',
    AU0012_INVALID_EXECUTION_STATUS: 'AU0012',
    AU0013_SCRIPT_VALIDATION_FAILED: 'AU0013',
    AU0014_INVALID_CRON_EXPRESSION: 'AU0014',
    AU0015_SCRIPT_EXCEEDS_MAX_SIZE: 'AU0015',
    AU0016_SCRIPT_COMPILATION_TIMEOUT: 'AU0016',
    AU0017_STATIC_JOB_SCHEDULE: 'AU0017',
    AU0018_CRON_SUB_MINUTE: 'AU0018',
    AU0019_CRON_INVALID_CHARS: 'AU0019',
    AU0020_CRON_TOO_LONG: 'AU0020',
    AU0021_DUPLICATE_NAME: 'AU0021',
    AU0022_EXPIRES_AT_IN_PAST: 'AU0022',
    AU0023_SERVICE_ACCOUNT_INACTIVE: 'AU0023',
    AU0024_API_KEY_NOT_FOUND: 'AU0024',
    AU0025_RATE_LIMIT_EXCEEDED: 'AU0025',
    AU0026_ROLE_KEY_ALREADY_EXISTS: 'AU0026',
    EN0001_DURATION_REQUIRED: 'EN0001',
    EN0002_RESOURCE_MISMATCH: 'EN0002',
    EN0003_BINDING_EXISTS: 'EN0003',
    EN0004_NOT_AUTO_ASSIGNABLE: 'EN0004',
    EN0005_NOT_REQUESTABLE: 'EN0005',
    EN0006_PROFILE_NOT_ACTIVE: 'EN0006',
    EN0007_PROFILES_REQUIRED: 'EN0007',
    EN0011_CODE_REQUIRED: 'EN0011',
    EN0012_CODE_INVALID: 'EN0012',
    EN0013_CODE_NOT_UNIQUE: 'EN0013',
    EN0014_CODE_IMMUTABLE: 'EN0014',
    PL0001_INVALID_POLICY_TYPE: 'PL0001',
    PL0002_INVALID_POLICY_STATUS: 'PL0002',
    GV0001_RULE_ID_REQUIRED: 'GV0001',
    GV0002_OPEN_REQUEST_EXISTS: 'GV0002',
    GV0003_RULE_ALREADY_ACTIVE: 'GV0003',
    GV0004_RULE_ALREADY_INACTIVE: 'GV0004',
    GV0005_INVALID_CONDITION: 'GV0005',
    GV0006_REQUEST_NOT_EDITABLE: 'GV0006',
    GV0007_REQUEST_VERSION_CONFLICT: 'GV0007',
    GV0008_CANNOT_DELETE_REQUEST: 'GV0008',
    GV0009_REJECTION_COMMENT_REQUIRED: 'GV0009',
    GV0010_TRANSITION_ERROR: 'GV0010',
    GV0011_ASSIGNMENT_ALREADY_REVOKED: 'GV0011',
    GV0012_NO_ACTIVE_STEP: 'GV0012',
    GV0013_NOT_ASSIGNED_APPROVER: 'GV0013',
    GV0014_RESTRICTION_VIOLATION: 'GV0014',
    GV0016_DELEGATION_SELF: 'GV0016',
    GV0017_DELEGATION_END_BEFORE_START: 'GV0017',
    GV0018_DELEGATION_MAX_DURATION: 'GV0018',
    GV0019_DELEGATION_DUPLICATE: 'GV0019',
    GV0020_DELEGATION_SUB_DELEGATION: 'GV0020',
    GV0021_DELEGATION_NOT_EDITABLE: 'GV0021',
    GV0022_DELEGATION_NOT_REVOCABLE: 'GV0022',
    GV0023_WORKFLOW_ITEM_ALREADY_COMPLETED: 'GV0023',
    GV0024_WORKFLOW_ITEM_WITHDRAWN: 'GV0024',
    GV0025_WORKFLOW_ITEM_CANNOT_WITHDRAW: 'GV0025',
    GV0026_WORKFLOW_ITEM_NO_IDENTITY: 'GV0026',
    GV0030_DELEGATION_STEP_OVERLAP: 'GV0030',
    GV0031_RESTORE_WINDOW_EXCEEDED: 'GV0031',
    GV0027_PROFILE_IDS_NOT_ALLOWED_FOR_FG_RULE: 'GV0027',
    GV0028_FG_IDS_NOT_ALLOWED_FOR_PROFILE_RULE: 'GV0028',
    GV0029_FG_NOT_AUTO_ASSIGNABLE: 'GV0029',
    GV0032_RULE_NO_OWNER: 'GV0032',
    GV0033_INVALID_CONDITION_FOR_POLICY_TYPE: 'GV0033',
    GV0034_INVALID_RESOLVER_FOR_POLICY_TYPE: 'GV0034',
    GV0035_CANNOT_CANCEL_NOT_OWNER: 'GV0035',
    GV0036_CANNOT_CANCEL_DECISIONS_RECORDED: 'GV0036',
    GV0037_CANNOT_CANCEL_NOT_PENDING: 'GV0037',
    GV0038_PROFILE_MODE_MUTUAL_EXCLUSIVE: 'GV0038',
    GV0039_PROFILE_MODE_REQUIRED: 'GV0039',
    GV0040_GRANT_IDENTITY_NOT_GRANT_ELIGIBLE: 'GV0040',
    GV0041_GRANT_PROFILE_INACTIVE: 'GV0041',
    GV0042_GRANT_RESTRICTION_VIOLATION: 'GV0042',
    GV0043_API_KEY_NOT_FOUND: 'GV0043',
    GV0044_SHORTEN_EXPIRY_BEFORE_START: 'GV0044',
    RP0009_CYCLE_DETECTED: 'RP0009',
    RP0010_MAX_DEPTH_EXCEEDED: 'RP0010',
    RP0014_MISSING_SQL_DEFINITION: 'RP0014',
    RP0015_BLANK_SQL: 'RP0015',
    RP0016_INVALID_SQL_PREFIX: 'RP0016',
    RP0017_INVALID_DML_PREFIX: 'RP0017',
    RP0018_INVALID_CRON_EXPRESSION: 'RP0018',
    CE0001_ONLY_STAGING_ACTIVATABLE: 'CE0001',
    CE0002_COMPLETED_NOT_CANCELLABLE: 'CE0002',
    CE0003_ALREADY_CANCELLED: 'CE0003',
    CE0004_IN_GENERATION_NOT_CANCELLABLE: 'CE0004',
    CE0005_ONLY_STAGING_DELETABLE: 'CE0005',
    CE0006_DEFAULT_POLICY_NOT_MODIFIABLE: 'CE0006',
    CE0007_DEFAULT_POLICY_NOT_DELETABLE: 'CE0007',
    CE0008_POLICY_HAS_CAMPAIGNS: 'CE0008',
    CE0009_DECISION_NOT_FOUND: 'CE0009',
    CE0010_AUTO_REVOKE_NOT_OVERRIDABLE: 'CE0010',
    CE0011_REVIEW_ITEM_COMPLETED: 'CE0011',
    CE0012_UNDECIDED_ASSIGNMENTS: 'CE0012',
    CE0013_CAMPAIGN_NOT_STARTED: 'CE0013',
    CE0014_PERFORMER_NOT_FOUND: 'CE0014',
    CE0015_SOURCE_TYPE_NOT_SUPPORTED: 'CE0015',
    CE0016_UNSUPPORTED_OPERATOR: 'CE0016',
    CE0017_CAMPAIGN_NOT_EDITABLE: 'CE0017',
    CE0018_CAMPAIGN_NO_POLICY: 'CE0018',
    CE0019_POLICY_NO_PARAMETERS: 'CE0019',
    CE0020_SCHEDULED_OWNER_NOT_FOUND: 'CE0020',
    CE0021_SCOPE_PREVIEW_TIMEOUT: 'CE0021',
    CE0022_SCOPE_PREVIEW_FAILED: 'CE0022',
    CE0023_CAMPAIGN_NO_ACTIVE_OWNER: 'CE0023',
    CN0001_NO_SPI_REGISTERED: 'CN0001',
    CN0002_INVALID_CONNECTOR_TYPE: 'CN0002',
    CN0003_UNSUPPORTED_AUTH_TYPE: 'CN0003',
    CN0004_ATTR_MAPPINGS_EMPTY: 'CN0004',
    CN0005_ATTR_MAPPING_BLANK_SOURCE: 'CN0005',
    CN0006_ATTR_MAPPING_SOURCE_TOO_LONG: 'CN0006',
    CN0007_ATTR_MAPPING_BLANK_TARGET: 'CN0007',
    CN0008_ATTR_MAPPING_TARGET_TOO_LONG: 'CN0008',
    CN0009_ATTR_MAPPING_TARGET_INVALID: 'CN0009',
    CN0010_ATTR_MAPPING_DUPLICATE_TARGET: 'CN0010',
    CN0011_ATTR_MAPPING_UNKNOWN_TYPE: 'CN0011',
    CN0012_ATTR_MAPPING_UNKNOWN_VARIABLE: 'CN0012',
    CN0013_ATTR_MAPPING_UNKNOWN_SOURCE: 'CN0013',
    CN0014_OU_ROUTING_DEFAULT_OU_BLANK: 'CN0014',
    CN0015_OU_ROUTING_DEFAULT_OU_TOO_LONG: 'CN0015',
    CN0016_OU_RULE_UNKNOWN_OPERATOR: 'CN0016',
    CN0017_IN_OPERATOR_TOO_MANY_VALUES: 'CN0017',
    CN0018_OBJECT_CLASSES_EMPTY: 'CN0018',
    CN0019_OBJECT_CLASS_INVALID: 'CN0019',
    CN0020_DN_TEMPLATE_BLANK: 'CN0020',
    CN0021_DN_TEMPLATE_MISSING_OU: 'CN0021',
    CN0022_COMPUTED_TEMPLATE_INVALID_SYNTAX: 'CN0022',
    CN0023_OBJECT_CLASSES_TOO_MANY: 'CN0023',
    CN0024_ATTR_MAPPING_TARGET_UNKNOWN_SCIM_PREFIX: 'CN0024',
    CN0025_SECRET_REF_PLAIN_FORBIDDEN_IN_PROD: 'CN0025',
    CN0026_SECRET_REF_FORMAT_INVALID: 'CN0026',
    CN0027_SECRET_REF_AUTH_INCOMPLETE: 'CN0027',
    CN0028_REST_OPERATION_HEADER_DUPLICATE_NAME: 'CN0028',
    CN0029_OU_RULE_VALUE_REQUIRED: 'CN0029',
    CN0030_TRANSFORM_ARG_REQUIRED: 'CN0030',
    CN0031_TRANSFORM_ARG_INVALID_REGEX: 'CN0031',
    CN0032_TRANSFORM_ARG_NOT_INTEGER: 'CN0032',
    CN0033_TRANSFORM_ARG_INVALID_VALUE: 'CN0033',
    CN0034_ATTR_MAPPING_UNKNOWN_TRANSFORM: 'CN0034',
    IC0001_ATTR_MAPPINGS_EMPTY: 'IC0001',
    IC0002_ATTR_MAPPING_BLANK_SOURCE: 'IC0002',
    IC0003_ATTR_MAPPING_SOURCE_TOO_LONG: 'IC0003',
    IC0004_ATTR_MAPPING_BLANK_TARGET: 'IC0004',
    IC0005_ATTR_MAPPING_TARGET_TOO_LONG: 'IC0005',
    IC0006_ATTR_MAPPING_UNKNOWN_TYPE: 'IC0006',
    IC0007_ATTR_MAPPING_UNKNOWN_ENTITY_TYPE: 'IC0007',
    IC0008_ATTR_MAPPING_UNKNOWN_TRANSFORM: 'IC0008',
    IC0009_ATTR_MAPPING_DUPLICATE_TARGET: 'IC0009',
    IC0010_COMPUTED_TEMPLATE_INVALID_SYNTAX: 'IC0010',
    IC0011_BASE_URL_BLOCKED: 'IC0011',
    IC0012_BASE_URL_INVALID: 'IC0012',
    IC0013_MTLS_DECODE_FAILED: 'IC0013',
    IC0014_MTLS_TRUSTSTORE_INVALID: 'IC0014',
    IC0015_MTLS_TRUSTSTORE_EMPTY: 'IC0015',
    IC0016_MTLS_TRUST_ALL_FORBIDDEN: 'IC0016',
    IC0017_MTLS_REQUIRED_REF_MISSING: 'IC0017',
    IC0018_SIGV: 'IC0018',
    IC0019_SIGV: 'IC0019',
    IC0020_SIGV: 'IC0020',
    IC0021_SIGV: 'IC0021',
    IC0022_SIGNED_REQUEST_ALGORITHM_INVALID: 'IC0022',
    IC0023_SIGNED_REQUEST_FIELD_REQUIRED: 'IC0023',
    IC0024_SIGNED_REQUEST_TEMPLATE_NEWLINE: 'IC0024',
    IC0025_SIGNED_REQUEST_UNKNOWN_PLACEHOLDER: 'IC0025',
    IC0026_SIGNED_REQUEST_KEY_INVALID: 'IC0026',
    IC0027_SIGNED_REQUEST_SIGNING_FAILED: 'IC0027',
    IC0028_KERBEROS_FIELD_REQUIRED: 'IC0028',
    IC0029_KERBEROS_KEYTAB_DECODE_FAILED: 'IC0029',
    IC0030_KERBEROS_LOGIN_FAILED: 'IC0030',
    IC0031_KERBEROS_KDC_UNREACHABLE: 'IC0031',
    IC0032_RESPONSE_FILTER_DUPLICATE_FIELD: 'IC0032',
    IC0033_RESPONSE_FILTER_INVALID_REGEX: 'IC0033',
    IC0034_GOOGLE_SA_FIELD_REQUIRED: 'IC0034',
    IC0035_GOOGLE_SA_KEY_INVALID: 'IC0035',
    IC0036_GOOGLE_SA_TOKEN_ENDPOINT_FAILED: 'IC0036',
    IC0037_GOOGLE_SA_SIGNING_FAILED: 'IC0037',
    IC0038_GOOGLE_SA_TOKEN_ENDPOINT_RATE_LIMITED: 'IC0038',
    IC0039_TRANSFORM_ARG_REQUIRED: 'IC0039',
    IC0040_TRANSFORM_ARG_INVALID_REGEX: 'IC0040',
    IC0041_TRANSFORM_ARG_NOT_INTEGER: 'IC0041',
    IC0042_TRANSFORM_ARG_INVALID_VALUE: 'IC0042',
    FG0002_AP_NOT_FOUND: 'FG0002',
    FG0003_CYCLE_DETECTED: 'FG0003',
    FG0004_SELF_PARENT: 'FG0004',
    FG0005_AP_ALREADY_LINKED: 'FG0005',
    FR0001_NOT_REQUESTABLE: 'FR0001',
    FR0002_DUPLICATE_IN_REQUEST: 'FR0002',
    FR0003_BENEFICIARY_NOT_ELIGIBLE: 'FR0003',
    FR0004_ITEM_NOT_PENDING: 'FR0004',
    FR0005_NOT_ASSIGNED_APPROVER: 'FR0005',
    FR0006_COMMENT_REQUIRED: 'FR0006',
    FR0007_ALREADY_ASSIGNED: 'FR0007',
    FR0008_PENDING_EXISTS: 'FR0008',
    FR0009_SELF_APPROVAL: 'FR0009',
    FR0010_RESTORE_WINDOW_EXCEEDED: 'FR0010',
    FR0011_MAX_DURATION_EXCEEDED: 'FR0011',
    FR0012_EXPIRY_REQUIRED: 'FR0012',
    EX0001_CURSOR_POSITION_EXCEEDS_LENGTH: 'EX0001',
    EX0002_ROOT_ENTITY_ID_REQUIRED: 'EX0002',
    EX0003_UNSUPPORTED_ROOT_TYPE: 'EX0003',
    EX0004_INACCESSIBLE_ROW_REFERENCES: 'EX0004',
    VA0001_MIN_LENGTH: 'VA0001',
    VA0002_MAX_LENGTH: 'VA0002',
    VA0003_PATTERN: 'VA0003',
    VA0004_ALLOWED_VALUES: 'VA0004',
    VA0005_MIN_VALUE: 'VA0005',
    VA0006_MAX_VALUE: 'VA0006',
    VA0007_MAX_OCCURRENCES: 'VA0007',
    VA0008_SINGLE_AND_MULTI_EXCLUSIVE: 'VA0008',
    VA0009_MULTI_ON_SINGLE_DEF: 'VA0009',
    VA0010_SINGLE_ON_MULTI_DEF: 'VA0010',
    VA0011_TYPE_CODES_NOT_SUPPORTED: 'VA0011',
    VA0012_INVALID_TYPE_CODE: 'VA0012',
    VA0013_DEFINITION_NOT_APPLICABLE: 'VA0013',
    VA0014_NAME_IMMUTABLE: 'VA0014',
    VA0015_DEFINITION_IMPACT_UNCONFIRMED: 'VA0015',
    VA0016_DEFINITION_IMPACT_CHANGED: 'VA0016',
    VA0017_DEFINITION_MIGRATION_RUNNING: 'VA0017',
    VA0018_MIGRATION_SQL_INVALID: 'VA0018',
    VA0019_UNIQUE_VALUE_VIOLATION: 'VA0019',
    VA0020_BULK_TARGET_REQUIRED: 'VA0020',
    VA0021_REORDER_EMPTY_LIST: 'VA0021',
    VA0022_REORDER_DUPLICATE_ID: 'VA0022',
    VA0023_REORDER_NEGATIVE_SORT_ORDER: 'VA0023',
    VA0024_REORDER_SORT_ORDER_EXCEEDS_MAX: 'VA0024',
    VA0025_REORDER_LIST_TOO_LARGE: 'VA0025',
    VA0026_BULK_IMPORT_EMPTY_REQUEST: 'VA0026',
    VA0027_BULK_IMPORT_ROW_LIMIT_EXCEEDED: 'VA0027',
    VA0028_BULK_IMPORT_MIXED_IDENTIFIERS: 'VA0028',
    VA0029_BULK_IMPORT_UNKNOWN_DEFINITION: 'VA0029',
    VA0030_BULK_IMPORT_MULTIPLE_IDENTIFIER_KEYS: 'VA0030',
    VA0031_BULK_IMPORT_EMPTY_VALUES: 'VA0031',
    VA0032_BULK_IMPORT_DELETE_WITH_VALUES: 'VA0032',
    VA0033_BULK_IMPORT_CREATE_WITH_IDENTIFIER: 'VA0033',
    VA0034_BULK_IMPORT_MISSING_IDENTIFIER: 'VA0034',
    VA0035_BULK_IMPORT_IDENTIFIER_NOT_UNIQUE: 'VA0035',
    VA0036_UNIQUE_ATTR_VALUE_IN_USE: 'VA0036',
    AT0001_RESERVED_FIELD_NAME: 'AT0001',
    AT0002_AUTHORITY_OWNED_MANUAL_OVERRIDE: 'AT0002',
    AT0003_AUTHORITY_TRANSFER_FROM_NULL: 'AT0003',
    AT0004_AUTHORITY_TARGET_SYSTEM_HAS_NO_SOURCE: 'AT0004',
    SR0001_SOURCE_NOT_OWNED_BY_ENTITY: 'SR0001',
    PS0001_DUPLICATE_SCHEMA_ENTRY: 'PS0001',
    PS0002_TYPE_NOT_FOUND: 'PS0002',
    PS0003_TYPE_INACTIVE: 'PS0003',
    PS0004_TRIPLE_IMMUTABLE: 'PS0004',
    PS0005_LABEL_REQUIRED: 'PS0005',
    PS0006_SCHEMA_VIOLATION: 'PS0006',
    PS0007_CARDINALITY_EXCEEDED: 'PS0007',
    PS0008_INVALID_ALIAS_NAME: 'PS0008',
    UO0001_PARTY_NOT_PERSON: 'UO0001',
    UO0002_PARTY_INACTIVE: 'UO0002',
    UO0003_XSS_DETECTED: 'UO0003',
    UO0004_NO_PRIMARY_IDENTIFIER: 'UO0004',
    UO0005_MULTIPLE_PRIMARY_IDENTIFIERS: 'UO0005',
    UO0006_DUPLICATE_IDENTIFIER_IN_REQUEST: 'UO0006',
    UO0007_ENTRY_DATE_IN_PAST: 'UO0007',
    UO0008_EXIT_DATE_BEFORE_ENTRY: 'UO0008',
    UO0009_PARTY_VERSION_REQUIRED: 'UO0009',
    UO0010_ATTRIBUTE_HR_MANAGED: 'UO0010',
    UO0011_RATE_LIMIT_EXCEEDED: 'UO0011',
    UO0012_TARGET_PARTY_ID_DEPRECATED: 'UO0012',
    UO0013_REQUIRED_PARTY_ATTRIBUTE_MISSING: 'UO0013',
    UO0014_REQUIRED_IDENTITY_ATTRIBUTE_MISSING: 'UO0014',
    VS0001_INAPPLICABLE_FIELD: 'VS0001',
    VS0002_WRONG_TYPE: 'VS0002',
    VS0003_INVALID_VALUE: 'VS0003',
    VS0004_CROSS_FIELD: 'VS0004',
    VS0005_MUST_BE_POSITIVE: 'VS0005',
    VS0006_MUST_BE_GREATER_THAN_ZERO: 'VS0006',
    VS0007_INVALID_REGEX: 'VS0007',
    VS0008_LIST_REQUIRES_VALUES: 'VS0008',
    VS0009_LIST_ENTRY_CODE_BLANK: 'VS0009',
    VS0010_LIST_ENTRY_LABEL_BLANK: 'VS0010',
    VS0011_LIST_ENTRY_CODES_UNIQUE: 'VS0011',
    VS0012_ENUM_REQUIRES_TYPE_NAME: 'VS0012',
    VS0013_UNKNOWN_TYPE: 'VS0013',
    VS0014_CUSTOM_LIST_REQUIRES_NAME: 'VS0014',
    VS0015_UNIQUE_STRING_ONLY: 'VS0015',
    VS0016_UNIQUE_NOT_MULTI_VALUED: 'VS0016',
    VS0017_UNIQUE_NOT_WITH_VALUE_SOURCE: 'VS0017',
    DA0001_DERIVED_OPERATIONS_MUST_BE_READ_ONLY: 'DA0001',
    DA0002_DERIVED_EXPRESSION_PARSE_ERROR: 'DA0002',
    DA0003_DERIVED_EXPRESSION_PATH_UNRESOLVABLE: 'DA0003',
    DA0004_DERIVED_EXPRESSION_TOO_LONG: 'DA0004',
    DA0005_DERIVED_EXPRESSION_PATH_SET_TOO_LARGE: 'DA0005',
    DA0006_DERIVED_EXPRESSION_CYCLE: 'DA0006',
    DA0007_DERIVED_ATTRIBUTE_NOT_WRITABLE: 'DA0007',
    AC0001_INVALID_TRANSITION: 'AC0001',
    AC0002_LIFECYCLE_REASON_TOO_LONG: 'AC0002',
    IS0001_CONNECTION_FAILED: 'IS0001',
    IS0002_AUTH_FAILED: 'IS0002',
    IS0003_PARSE_ERROR: 'IS0003',
    IS0004_CORRELATION_FAILED: 'IS0004',
    IS0005_RECONCILE_ERROR: 'IS0005',
    IS0006_INVALID_ENUM_VALUE: 'IS0006',
    IS0007_CONNECTOR_DISABLED: 'IS0007',
    IS0008_WRONG_CONNECTOR_TYPE: 'IS0008',
    IS0009_INVALID_RECORD_ACTION: 'IS0009',
    VL0001_LIST_NOT_FOUND: 'VL0001',
    VL0002_ENTRY_NOT_FOUND: 'VL0002',
    VL0003_NAME_DUPLICATE: 'VL0003',
    VL0004_CODE_DUPLICATE: 'VL0004',
    VL0005_LIST_IN_USE: 'VL0005',
    VL0006_LIST_NOT_ACTIVE: 'VL0006',
    TR0001_DUPLICATE_TRIPLE: 'TR0001',
    TR0002_VERSION_MISMATCH: 'TR0002',
    TR0003_LABEL_REQUIRED: 'TR0003',
    OB0001_INVALID_UUID: 'OB0001',
    OB0002_INVALID_INSTANT: 'OB0002',
    OB0003_INVALID_TRACE_ID: 'OB0003',
    OB0004_INVALID_CORRELATION_ID: 'OB0004',
    OB0005_INVALID_SLOWER_THAN_MS: 'OB0005',
    OB0006_INVALID_PAGE: 'OB0006',
    OB0007_INVALID_SIZE: 'OB0007',
    OB0008_SESSION_MISMATCH: 'OB0008',
    OB0009_SENSITIVE_ATTRIBUTE: 'OB0009',
    OB0010_UNKNOWN_ATTRIBUTE: 'OB0010',
    OB0011_RATE_LIMIT_SESSION: 'OB0011',
    OB0012_RATE_LIMIT_USER: 'OB0012',
    OB0013_BATCH_TOO_LARGE: 'OB0013',
} as const
/* eslint-enable i18next/no-literal-string, no-restricted-syntax */

export type IamErrorCode = (typeof IamErrorCode)[keyof typeof IamErrorCode]
